import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";

angular
  .module('bringoz.admin.planning')
  .factory('$drafts', planningDraftsObjectFactory);

/* @ngInject */
function planningDraftsObjectFactory($bringozFactory: $bringozFactory,
                                     PlanningDraftsAPI: BringozApi,
                                     Planning_Drafts_DS: DataStoreConfig,
                                     Drafts_PN: PushNotificationsConfig) {

  function $drafts(id: string) {
    return $bringozFactory(id, PlanningDraftsAPI, Planning_Drafts_DS, Drafts_PN)
  }

  return $drafts
}
